"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _index = _interopRequireWildcard(require("../@i18n/index"));
var _common = require("../@api/common");
var _store = require("../@api/store");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/// GROUP CHAT based on appcenter groups

var Sidebar = function Sidebar(_ref) {
  var appcenterStore = _ref.appcenterStore,
    items = _ref.items;
  var _useState = (0, _react.useState)('opened'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var toggle = function toggle() {
    setOpened(oppened === 'opened' ? 'closed' : 'opened');
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "sidebar",
    style: {
      background: whitelabel && whitelabel.background ? whitelabel.background : false,
      color: whitelabel ? whitelabel.color : false
    },
    className: "".concat(opened),
    onClose: function onClose() {
      return setOpened('closed');
    },
    onKeyDown: function onKeyDown() {
      return setOpened('closed');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-space"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon toggler",
    onClick: toggle
  }, !drawerOpen ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faChevronRight"
  }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faChevronLeft"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setOpened('closed');
    }
  }, modules.map(function (module, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "items"
    }, module.items.map(function (item, a) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "item",
        key: a,
        onClick: item.onClick
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "icon"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: item.icon
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "name"
      }, item.name), /*#__PURE__*/_react["default"].createElement("div", {
        className: "description"
      }, item.description)));
    }));
  })));
};
var _default = Sidebar;
exports["default"] = _default;